export const main = (filters) => [
  {text: '', value: 'actions', width: '80px'},
  // { text: 'ID', align: 'start', value: 'id', width: '5rem',  
  //     filter: value => {
  //                 if ( !filters.find(x=>x.name === 'id')?.value) return true
  //                 return value == filters.find(x=>x.name === 'id')?.value
  //     }
  // },
  // { text: 'Tháng khởi tạo', align: 'start', value: 'employeeReadyReviewMonth', width: '7rem',
  //     filter: value => true
  // },
  { text: 'Phân loại', align: 'start', value: 'type', width: '3rem',  
      filter: value => true
  },
  
  { text: 'ID', align: 'start', value: 'id', width: '5rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'id')?.value) return true
        return value.includes(filters.find(x=>x.name === 'id')?.value)
      }
  },
  { text: 'Nội dung', align: 'start', value: 'body', width: '20rem',  
      filter: value => {
        if ( !filters.find(x=>x.name === 'body')?.value) return true
        return value.includes(filters.find(x=>x.name === 'body')?.value)
      }
  },
  { text: 'Định danh', align: 'start', value: 'identify', width: '7rem',
      filter: value => true
  },
  
  { text: 'Mã NS', align: 'start', value: 'employeeCode', width: '7rem',
      filter: value => true
  },
  
  { text: 'Trạng thái', align: 'start', value: 'status', width: '12rem',
      filter: value => true
  },
  // { text: 'Tên NS', align: 'start', value: 'employeeName', width: 'auto',
  //     filter: value => true
  // },
  { text: 'Thời gian', align: 'start', value: 'createdAt', width: 'auto',
      filter: value => true
  },

]

export const view = (filters) => [
//   {text: '', value: 'actions', width: 100},
  { text: 'ID', align: 'start', value: 'id', width: '5rem',  
      filter: value => {
                  if ( !filters.find(x=>x.name === 'id')?.value) return true
                  return value == filters.find(x=>x.name === 'id')?.value
      }
  },
  
  { text: 'Nhóm', align: 'start', value: 'conditionGroup', width: '10rem',},
  { text: 'Điều kiện', align: 'start', value: 'conditionTitle' },
  
  { text: 'Đánh giá', align: 'start', value: 'score' }
]

export const finalHeaders = [
  // {text: '', value: 'actions', width: 100},
  { text: 'Tháng', align: 'start', value: 'month', width: '7rem' },
  // { text: 'Tổng phiếu', align: 'start', value: 'count' },
  { text: 'Số nhân sự', align: 'start', value: 'employeeCount' },
  { text: 'Số NVM', align: 'start', value: 'final.totalReviewNvm' },
  { text: 'Số NVM đạt', align: 'start', value: 'final.completeNvm' },
  { text: 'Số COT2', align: 'start', value: 'final.totalReviewCot2' },
  { text: 'Số COT2 đạt', align: 'start', value: 'final.completeCot2' },
  // { text: 'Trạng thái', align: 'start', value: 'status' },
  { text: 'Chốt kỳ', align: 'start', value: 'setFinal' },
  { text: 'Reset', align: 'start', value: 'resetFinal' },
  // { text: 'Chưa hoàn tất NVM', align: 'start', value: 'incompleteNvm' },
  // { text: 'Hoàn tất NVM', align: 'start', value: 'completeNvm' },
  // { text: 'Tổng phiếu NVM', align: 'start', value: 'totalReviewNvm' },
  // { text: 'Chưa hoàn tất COT2', align: 'start', value: 'incompleteCot2' },
  // { text: 'Hoàn tất COT2', align: 'start', value: 'completeCot2' },
  // { text: 'Tổng phiếu COT2', align: 'start', value: 'totalReviewCot2' },
]

export const readyHeaders = [
  { text: 'Mã nhân viên', align: 'start', value: 'employeeCode' },
  { text: 'Tên nhân viên', align: 'start', value: 'employeeName' },
  { text: 'Ngày nhận việc', align: 'start', value: 'hireDate' },
  { text: 'Phân loại', align: 'start', value: 'type' },
  { text: 'Mã NS đánh giá', align: 'start', value: 'finalManagerCode' },
  { text: 'Người đánh giá', align: 'start', value: 'finalManagerName' },
  { text: 'Chỉ định người đ/giá (tạm thời)', align: 'start', value: 'smCode' },
]